import { render, staticRenderFns } from "./filter-indicators.component.vue?vue&type=template&id=f096cfd2&scoped=true"
import script from "./filter-indicators.component.vue?vue&type=script&lang=js"
export * from "./filter-indicators.component.vue?vue&type=script&lang=js"
import style0 from "./filter-indicators.component.vue?vue&type=style&index=0&id=f096cfd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f096cfd2",
  null
  
)

export default component.exports